  <div>

    <div class="info-text">
    <span class="syn-body--medium">
      Welcome
      <br>
      <br>
      You can use this service to convert Safety Designer project files with the .sdp extension to our new file format with the .sdp2 extension.
    </span>
    </div>

    <syn-button
      class="button"
      variant="filled"
      (click)="onClick()"
      (keyup)="onKeyUp($event)">
      <syn-icon slot="prefix" name="login"></syn-icon>
      Login
    </syn-button>

  </div>
